export default "__VITE_ASSET__oRLroDQy__"